// Global Instructions Rule Applied!
// Grid row shape of POST /fund-transactions/filter (view__fund_transactions).
import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const FundTransactionRecordSchema = z
  .object({
    fund_transactions__id: z.string(),
    funds__id: z.string(),
    funds__name: z.string().nullish(),
    cfg_fund_transaction_types__id: z.number().nullish(),
    cfg_fund_transaction_types__label: z.string().nullish(),
    fund_transactions__transaction_date: z.string().nullish(),
    fund_transactions__transaction_date_fmt: z.string().nullish(),
    fund_transactions__description: z.string().nullish(),
    cfg_transaction_statuses__id: z.number().nullish(),
    cfg_transaction_statuses__label: z.string().nullish(),
    currencies__id: z.string().nullish(),
    currencies__code: z.string().nullish(),
    fund_transactions__total_amount: z.number().nullish(),
    fund_transactions__total_amount_fmt: z.string().nullish(),
    fund_transactions__journal_count: z.number().nullish(),
    fund_transactions__is_balanced: z.boolean().nullish(),
    fund_transactions__capital_call_id: z.string().nullish(),
    fund_transactions__distribution_id: z.string().nullish()
  })
  .strict()

export const FundTransactionRecordFields = makeFieldKeys(FundTransactionRecordSchema)

export type FundTransactionRecord = z.infer<typeof FundTransactionRecordSchema>

export function validateFundTransactionRecord(data: unknown, isArray: true): FundTransactionRecord[]
export function validateFundTransactionRecord(data: unknown, isArray?: false): FundTransactionRecord
export function validateFundTransactionRecord(data: unknown, isArray?: boolean): FundTransactionRecord | FundTransactionRecord[]
export function validateFundTransactionRecord(data: unknown, isArray = false): FundTransactionRecord | FundTransactionRecord[] {
  try {
    return validateWithZodSchema(FundTransactionRecordSchema, data, 'fund transaction record', { isArray })
  } catch (error) {
    throw new Error(`Fund transaction record validation failed: ${error}`)
  }
}
